import { createRoute } from "@tanstack/solid-router";
// FLAGS: la página entera se gatea por la vertical de titularidad (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { msg } from "@lingui/core/macro";
import { ShieldCheck } from "lucide-solid";
import { appRoute } from "./route";
import { useI18n } from "@/providers/i18n-provider";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { EntitlementAdmin } from "@/features/entitlement/entitlement-admin";

function EntitlementPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="6xl">
      <PageHeader
        title={t(msg`Entitlement`)}
        description={t(
          msg`Decide what happens when a student hasn't paid — for the whole academy, for one course or for one student. Grades and attendance are never withheld.`,
        )}
        icon={ShieldCheck}
      />
      <div class="mt-4">
        <EntitlementAdmin />
      </div>
    </PageContainer>
  );
}

export const academyEntitlementRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/academy/entitlement",
  component: withFeatureGate("academy.entitlement", EntitlementPage),
});
